import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.string.includes.js';
import { __decorate, __param, __metadata } from '../../_virtual/_tslib.js';
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';
import { Envs } from '../envs.js';

let GetAssetSignedUrl = class GetAssetSignedUrl {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(input) {
    const body = {
      name: input.name,
      description: input.description ? input.description : '',
      mimeType: input.mimeType
    };
    return new Promise((resolve, reject) => {
      this.httpClient.request({
        url: `${Envs.BFF_MEMBERS_AREA_URL}/assets`,
        body,
        headers: {
          accept: 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        method: HttpMethod.POST
      }).then(({
        statusCode,
        data
      }) => {
        if (statusCode === undefined) {
          return false;
        }
        if (!data || ![HttpStatusCode.CREATED, HttpStatusCode.OK].includes(statusCode)) {
          return reject(`Ocorreu um erro na url assinada upload de arquivo`); //@TODO error code of bff
        }
        return resolve(data);
      }).catch(() => {
        return reject(`Ocorreu um erro na url assinada upload de arquivo`); //@TODO error code of bff
      });
    });
  }
};
GetAssetSignedUrl = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], GetAssetSignedUrl);

export { GetAssetSignedUrl };
